"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const PanelViewMap_vue_1 = __importDefault(require("./PanelViewMap.vue"));
const ProjectsController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ProjectsController"));
const MapSideBar_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapSideBar.vue"));
const MapSideBarRight_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapSideBarRight.vue"));
const ScopeBar_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/ScopeBar.vue"));
const SideBySideOverlay_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/SideBySideOverlay/SideBySideOverlay.vue"));
const LoaderMap_vue_1 = __importDefault(require("../LoaderMap.vue"));
const NeedMap_1 = require("@becrop/abstract/Models/NeedMap");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const trans_1 = require("@common/tsutils/trans");
let AreaProjectResultsMap = class AreaProjectResultsMap extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isLoadingOpenReport = false;
        this.areaProjectMapController = new ProjectsController_1.default();
        this.isMapScreenshot = false;
        this.changePanel = false;
        this.showRecommendations = false;
        this.currentScope = 'block';
        this.lastPanelClicked = 'main';
        this.mapSideBarPanel = '';
        this.mapSideBarPanelRight = '';
        this.rendering = false;
        this.isLoadingFetchFarms = false;
        this.fieldActiveKey = '';
        this.polygonSelectedItem = '';
        this.downloadReportAction = false;
    }
    async mainActionClicked(field) {
        this.isLoadingOpenReport = true;
        const mapPanel = this.$refs.mapPanel;
        await mapPanel.openFpdfReport(field);
        this.isLoadingOpenReport = false;
    }
    openSideBarPanel(panel) {
        const sideBar = this.$refs.mapSideBar;
        sideBar.activePanel = panel;
    }
    focusField(field) {
        const mapPanel = this.$refs.mapPanel;
        mapPanel.focusField(field);
    }
    get currentFarm() {
        return this.areaProjectMapController.currentSelectedFarm;
    }
    selectFarm(farm) {
        this.areaProjectMapController.selectFarm(farm);
    }
    setRendering() {
        this.rendering = true;
    }
    unsetRendering() {
        this.rendering = false;
    }
    async updateSbSProject(farm, i) {
        this.areaProjectMapController.farmComparisonState[i].isLoading = true;
        await this.areaProjectMapController.loadProject(farm);
        this.areaProjectMapController.updateSbSStates();
        this.areaProjectMapController.farmComparisonState[i].onChangeFarm(farm);
        this.areaProjectMapController.farmComparisonState[i].isLoading = false;
        //await this.areaProjectMapController.farmComparisonState[i].onChangeFarm(farm)
    }
    updateSbSMetric(metric, i) {
        this.areaProjectMapController.farmComparisonState[i].onChangeMetric(metric);
    }
    updateFieldActiveKey(f) {
        this.fieldActiveKey = f;
    }
    updateSideBarPanelRight(panel) {
        if (this.mapSideBarPanelRight === panel) {
            this.mapSideBarPanelRight = '';
        }
        else {
            this.mapSideBarPanelRight = panel;
        }
    }
    updateSideBarPanel(panel) {
        this.unsetRendering();
        (this.mapSideBarPanel === panel) ?
            this.mapSideBarPanel = '' :
            this.mapSideBarPanel = panel;
        if (this.mapSideBarPanel === 'need-maps' && this.entityType === 'farms') {
            this.updateNeedMap(new NeedMap_1.NeedMap({ 'slug': 'aigen' }));
        }
        this.showRecommendations = false;
    }
    polygonSelected(polygon) {
        this.polygonSelectedItem = polygon;
    }
    get hasProjects() {
        const params = new URLSearchParams(window.location.search);
        const projectId = params.get('projectId');
        const areaId = params.get('areaId');
        return projectId && areaId ? true : false;
    }
    async mounted() {
        const params = new URLSearchParams(window.location.search);
        const projectId = params.get('projectId');
        const areaId = params.get('areaId');
        this.areaProjectMapController.setProductPermissions(this.data.user.product_level);
        await this.fetchFarms();
        if (projectId && areaId) {
            await this.areaProjectMapController.loadInitialProject();
            await this.areaProjectMapController.fetchProducts();
            await this.areaProjectMapController.fetchProjectList();
            await this.areaProjectMapController.fillCropsInBuilt();
        }
        if (params.get('farm_list') === 'true') {
            let farmId = params.get('farm_id');
            this.updateSideBarPanel('farms');
            if (parseInt(farmId) >= 0) {
                const farm = this.farmsList.find((f) => f.id == parseInt(farmId));
                if (farm) {
                    this.selectFarm(farm);
                }
                else {
                    if (this.farmsList.length > 0) {
                        this.selectFarm(this.farmsList[0]);
                    }
                    else {
                        this.selectFarm(null);
                    }
                }
            }
        }
        else {
            if (!projectId && !areaId) {
                if (this.farmsList.length > 0) {
                    this.selectFarm(this.farmsList[0]);
                    this.updateSideBarPanel('farms');
                }
                else {
                    this.selectFarm(null);
                }
            }
            else {
                const built = this.areaProjectMapController.projectsListBuilt.find((pb) => pb.area_id === parseInt(areaId));
                if (built) {
                    const farmId = built.farm_id;
                    const theFarm = this.farmsList.find((f) => f.id === farmId);
                    this.selectFarm(theFarm);
                }
            }
            this.updateSideBarPanel('metrics');
        }
    }
    get isEnabledNeedMap() {
        return !(Object.keys(this.mainSingleProjectDelivery.needsMaps).length === 0);
    }
    // get hasProductPermissions() {
    //     return this.areaProjectMapController.hasProductPermissions
    // }
    handleKeyDown(event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            if (!this.isSomethingLoading) {
                this.areaProjectMapController.manageProjectMetricNavigation(event.key, this.lastPanelClicked);
            }
        }
        //|| event.key === 'ArrowUp' || event.key === 'ArrowDown'
    }
    downloadReport(value) {
        this.downloadReportAction = !this.downloadReportAction;
    }
    panelClicked(p) {
        this.lastPanelClicked = p;
    }
    loadPreviousMetric(p) {
        if (this.hasDoblePanel) {
            if (this.currentDimension === 'bio') {
                this.areaProjectMapController.loadPreviousVSMetric(false, p);
            }
            else {
                this.areaProjectMapController.loadPreviousVSPhChMetric(false, p);
            }
        }
        else {
            if (this.currentDimension === 'bio') {
                this.areaProjectMapController.loadPreviousMetric(false);
            }
            else {
                this.areaProjectMapController.loadPreviousPhChMetric();
            }
        }
    }
    loadNextMetric(p) {
        if (this.hasDoblePanel) {
            if (this.currentDimension === 'bio') {
                this.areaProjectMapController.loadNextVSMetric(false, p);
            }
            else {
                this.areaProjectMapController.loadNextVSPhChMetric(false, p);
            }
        }
        else {
            if (this.currentDimension === 'bio') {
                this.areaProjectMapController.loadNextMetric(false);
            }
            else {
                this.areaProjectMapController.loadNextPhChMetric();
            }
        }
    }
    get entityType() {
        return this.areaProjectMapController.entityType;
    }
    get scale() {
        return this.areaProjectMapController.scale;
    }
    get comparisonReport() {
        return this.areaProjectMapController.comparisonReport;
    }
    get hasDoblePanel() {
        return this.areaProjectMapController.isDobleMode;
    }
    get projects() {
        if (this.hasDoblePanel) {
            return this.areaProjectMapController.projectsListBuilt.filter((p) => p.project_type !== 'farm');
        }
        else {
            return this.areaProjectMapController.projectsListBuilt;
        }
    }
    get secondaryProjects() {
        return this.areaProjectMapController.projectsListSecondaryBuilt;
    }
    get downloadedProjects() {
        return this.areaProjectMapController.downloadedSingleProjects;
    }
    get compositableProjects() {
        return this.areaProjectMapController.compositableProjects;
    }
    get isLoadingList() {
        return this.areaProjectMapController.isLoadingList;
    }
    get isLoadingMainDelivery() {
        return this.areaProjectMapController.isLoadingMainDelivery;
    }
    get isLoadingSecondaryDelivery() {
        return this.areaProjectMapController.isLoadingSecondaryDelivery;
    }
    get isLoadingComparison() {
        return this.areaProjectMapController.isLoadingComparison;
    }
    get isSomethingLoading() {
        return this.isLoadingList || this.isLoadingMainDelivery || this.isLoadingFetchFarms;
    }
    get mainSingleProjectBuilt() {
        return this.areaProjectMapController.mainSingleProjectBuilt;
    }
    get mainSingleProjectDelivery() {
        return this.areaProjectMapController.mainSingleProjectDelivery;
    }
    get mainSingleMetric() {
        return this.areaProjectMapController.mainSingleMetric;
    }
    get mainSingleMetricAgInsights() {
        return this.areaProjectMapController.mainSingleMetricAgInsights;
    }
    get mainSinglePhChMetric() {
        return this.areaProjectMapController.mainSinglePhChMetric;
    }
    async fetchFarms() {
        this.isLoadingFetchFarms = true;
        await this.areaProjectMapController.fetchFarmList();
        this.isLoadingFetchFarms = false;
    }
    get farmsList() {
        return this.areaProjectMapController.farmsList;
    }
    get currentNeedMap() {
        return this.areaProjectMapController.needMap;
    }
    get secondarySingleProjectBuilt() {
        return this.areaProjectMapController.secondarySingleProjectBuilt;
    }
    get secondarySingleProjectDelivery() {
        return this.areaProjectMapController.secondarySingleProjectDelivery;
    }
    get secondarySingleMetric() {
        return this.areaProjectMapController.secondarySingleMetric;
    }
    get areEqualProjects() {
        return this.areaProjectMapController.areEqualProjects;
    }
    get areEqualAreas() {
        return this.areaProjectMapController.areEqualAreas;
    }
    get mainHigherMetrics() {
        return this.areaProjectMapController.mainHigherMetrics;
    }
    get secondaryHigherMetrics() {
        return this.areaProjectMapController.secondaryHigherMetrics;
    }
    get mainHigherPhChMetrics() {
        return this.areaProjectMapController.mainHigherMetricsPhCh;
    }
    get secondaryHigherPhChMetrics() {
        return this.areaProjectMapController.secondaryHigherMetricsPhCh;
    }
    get mainHigherPhChGeneralInsights() {
        return this.areaProjectMapController.mainHigherPhChGeneralInsights;
    }
    get secondaryHigherPhChGeneralInsights() {
        return this.areaProjectMapController.secondaryHigherPhChGeneralInsights;
    }
    get highlightedComparisonMetric() {
        return this.areaProjectMapController.highlightedComparisonMetric;
    }
    get highlightedComparisonPhChMetric() {
        return this.areaProjectMapController.highlightedComparisonPhChMetric;
    }
    get multiDimensionalComparison() {
        return this.areaProjectMapController.multidimensionalComparison;
    }
    get loadingDetailStatus() {
        let message = '';
        let place = '';
        if (this.isLoadingList) {
            message = (0, trans_1.trans)('results_view_map.loading.list');
            place = 'list';
        }
        if (this.isLoadingMainDelivery) {
            message = (0, trans_1.trans)('results_view_map.loading.result');
            place = 'delivery';
        }
        if (this.isLoadingSecondaryDelivery) {
            message = (0, trans_1.trans)('results_view_map.loading.result');
            place = 'delivery2';
        }
        if (this.isLoadingComparison) {
            message = (0, trans_1.trans)('results_view_map.loading.comparison');
            place = 'comparison';
        }
        if (this.isLoadingFetchFarms) {
            message = (0, trans_1.trans)('results_view_map.loading.farms');
            place = 'farms';
        }
        return {
            state: this.isSomethingLoading,
            message: message,
            type: place,
        };
    }
    get isComparisonMode() {
        if (this.hasDoblePanel && this.areEqualProjects && !this.areEqualAreas)
            return true;
        return false;
    }
    get currentDimension() {
        return this.areaProjectMapController.dimension;
    }
    switchDimension(k) {
        this.areaProjectMapController.switchDimension(k);
    }
    mapScreenshot(value) {
        this.isMapScreenshot = value;
    }
    async updateMainProjectSelected(model) {
        this.areaProjectMapController.renderMainProjectSelected(model);
        await this.areaProjectMapController.fetchProducts();
    }
    updateFarmSelected(f) {
        this.areaProjectMapController.selectFarm(f);
    }
    updateSecondaryProjectSelected(model) {
        this.areaProjectMapController.renderSecondaryProjectSelected(model);
    }
    updateMainCurrentMetric(metric) {
        this.areaProjectMapController.setMainMetric(metric);
    }
    updatePhChMetric(metric) {
        this.areaProjectMapController.setMainPhChMetric(metric);
    }
    updateMainCurrentPhChMetric(metric) {
        this.areaProjectMapController.setMainPhChMetric(metric);
    }
    get currentMetricCompare() {
        return this.areaProjectMapController.highlightedComparisonMetric;
    }
    updateComparisonMetric(m, panel) {
        this.areaProjectMapController.setComparisonMetric(m, panel);
    }
    updateComparisonPhChMetric(m, panel) {
        this.areaProjectMapController.setComparisonPhChMetric(m, panel);
    }
    buildComparisonRank(panel) {
        if (this.highlightedComparisonMetric.higherIn === panel) {
            return this.highlightedComparisonMetric.baseMetric.rank;
        }
        return this.highlightedComparisonMetric.rankDefeated;
    }
    buildComparisonScore(panel) {
        if (this.highlightedComparisonMetric.higherIn === panel) {
            return this.highlightedComparisonMetric.baseMetric.score;
        }
        return this.highlightedComparisonMetric.scoreDefeated;
    }
    buildPhChComparisonScore(panel) {
        if (this.highlightedComparisonPhChMetric.higherIn === panel) {
            return this.highlightedComparisonPhChMetric.baseMetric.score.toFixed();
        }
        else {
            const defeated = this.highlightedComparisonPhChMetric.baseMetric.score / (1 + this.highlightedComparisonPhChMetric.difference / 100);
            return defeated.toFixed();
        }
    }
    updateNeedMap(needMap) {
        this.areaProjectMapController.setNeedMap(needMap);
    }
    toggleRecommendations(show) {
        this.showRecommendations = show;
    }
    // DOBLE PANEL MANAGEMENT
    deployDoblePanel() {
        this.areaProjectMapController.deployDobleMode();
        this.changePanel = true;
    }
    dismissDoblePanel() {
        this.areaProjectMapController.dismissDobleMode();
        this.changePanel = false;
    }
    get isSideBySideFarmMode() {
        return this.areaProjectMapController.isSideBySideFarmMode;
    }
    get farmComparisonState() {
        return this.areaProjectMapController.farmComparisonState;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], AreaProjectResultsMap.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], AreaProjectResultsMap.prototype, "data", void 0);
AreaProjectResultsMap = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBar: MapSideBar_vue_1.default,
            ScopeBar: ScopeBar_vue_1.default,
            PanelViewMap: PanelViewMap_vue_1.default,
            SideBySideOverlay: SideBySideOverlay_vue_1.default,
            LoaderMap: LoaderMap_vue_1.default,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            Loader: bmk_ui_framework_1.Loader,
            Chart3: bmk_ui_framework_1.Chart3,
            MapPin: lucide_vue_next_1.MapPin, MapSideBarRight: MapSideBarRight_vue_1.default
        },
    })
], AreaProjectResultsMap);
exports.default = AreaProjectResultsMap;
